import Vue from "vue";
import {GenericTableSelectMode} from "../GenericTableSelectMode";
import {IRow} from "../GenericTableRow";

/** Strategie pour un "GenericTable" sans selection */
export class GenericTableModeNoSelect extends GenericTableSelectMode {

    /** Application concrète de l'initialisation des paramètre pour "aucune selection possible" */
    public Initialize(): void {
        Vue.set(this.context, 'EnableToggleSelectionAll', false);
        Vue.set(this.context, 'EnableMenuLeft', true);
        Vue.set(this.context, 'EnableSelectorCheckBox', false);
        Vue.set(this.context, 'EnableSelectorRow', false);
        Vue.set(this.context, 'ShowSelectedCount', false);
    }

    /**
     * Permute l'état de selection de toute les lignes
     * @param row Lignes dont l’état de sélection doit être inversé
     * @param isDisplayed Indique si la ligne est affichés visuelement dans la page en cours
     */
    public ToggleRow(row: IRow, displayedRows: boolean): void {
        // RIEN CAR PAS DE SELECTION
    }

    /**
     * Permute l'état de selection de toute les lignes
     */
    public ToggleRows(): void {
        // RIEN CAR PAS DE SELECTION
    }

    /**
     * Permute l'état de selection de toute les lignes affichés sur la page en cours
     */
    public ToggleDisplayedRows(): void {
        // RIEN CAR PAS DE SELECTION
    }
}